
import { DownOutlined } from "@ant-design/icons";
import styled from "styled-components";

interface AdjustableSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const AdjustableSection = ({ title, children, className }: AdjustableSectionProps) => {
  return (
    <>
      {title && (
        <SToggle
          className={className}
        >
          {title}
        </SToggle>
      )}

      {children}
    </>
  )
}

const SToggle = styled.div`
  margin-bottom: 24px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  height: 24px;
  cursor: pointer;
  width: fit-content;
  user-select: none;
  margin-left: 4px;
`

const SDownIcon = styled(DownOutlined)`
  margin-left: 4px;

  &.rotate {
    transform: rotate(180deg);
  }
`
